export default "__VITE_ASSET__7f796de2__"